import { Accordion } from "@components/atoms/Accordion"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Accordion",
  icon: "info",
  keywords: "faq",
  tags: ["#subpage"],
  flags: {
    contentWidth: true,
    marginRule: "long-card",
  },
  blockStyles: [
    {
      name: "default",
      label: "Default",
      isDefault: true,
    },
    {
      name: "branded",
      label: "Branded",
    },
    {
      name: "disabled",
      label: "Disabled",
    },
  ],
}

export default defineBlock("content/accordion", (props) => {
  return (
    <Accordion
      title={
        <EditableText
          store="title"
          defaultValue="Enter some text here"
          placeholder="Enter a title"
          plainText
          disableLineBreaks
        />
      }
      data-mixpanel-block="Accordion"
    >
      <InnerBlocks allowedBlocks={["core/paragraph", "core/list", "content/button-row", "content/table"]} />
    </Accordion>
  )
})
